module.exports = __webpack_public_path__ + "img/2-7-venetian.4d004879.jpg";